import * as api from '../api';
import * as types from './types';

export const shardsLoading = () => {
	return {
		type: types.SHARDS_LOADING
	}
}

export const receiveShards = (shards) => {
	return {
		type: types.RECEIVE_SHARDS,
		shards
	}
}

export const fetchShards = () => {
	return async (dispatch, getState) => {
		if(!getState().shards.isLoaded && !getState().shards.isLoading) {
			dispatch(shardsLoading());

			const shards = await api.fetchShards();

			dispatch(receiveShards(shards));
		}
	}
}


// WEBPACK FOOTER //
// ./src/actions/shard.js